/**
 * Converts strings emitted by payment gateways to human-readable string for registrations/order `paymentMethod` API
 * @param {string} paymentType String emitted by payment gateway as paymentType. If no string emitted (i.e non-Braintree payments), provide one and add to dictionary
 * @returns {string} String required for placing in API `paymentMethod` for registrations/order.
 */

export const paymentDict = paymentType => {
  // paymentType is only emitted by Braintree.
  // Adding another payment gateway? Simply emit a suitable paymentType
  // prop and add the value below.
  switch (paymentType) {
    case 'CreditCard':
      return 'Braintree - Credit Card'
    case 'AndroidPayCard':
      return 'Braintree - Google Pay'
    case 'ApplePayCard':
      return 'Braintree - Apple Pay'
    case 'PayPalAccount':
    case 'PayPal':
      return 'Braintree - PayPal'
    default:
      return null
  }
}
